import { useMemo, useState } from 'react'
import { computeResults, DEFAULT_STATE } from '../_utils/calculator'
import type { CareerBreakResults, CareerBreakState } from '../types'

export type SetField = <K extends keyof CareerBreakState>(key: K, value: CareerBreakState[K]) => void

export function useCalculator(): {
  state: CareerBreakState
  set: SetField
  results: CareerBreakResults
} {
  const [state, setState] = useState<CareerBreakState>(DEFAULT_STATE)

  const set: SetField = (key, value) =>
    setState((prev) => {
      const next = { ...prev, [key]: value }
      // Losing the partner also loses their health plan; without this the segmented
      // control would sit on an option it no longer offers.
      if (next.coverage === 'partner' && !(next.household === 'couple' && next.partnerWorks === 'yes')) {
        next.coverage = 'cobra'
      }
      return next
    })

  const results = useMemo(() => computeResults(state), [state])

  return { state, set, results }
}
